import React from 'react'
import ReactDOM from 'react-dom'
import PrepressExtraCopyItem from './PrepressExtraCopyItem'

class PrepressExtraCopiesIndex extends React.Component {

  humanizeStatus() {
    return {
      'extra_copies': 'Extra Copies',
      'in_extra_copies': 'In Extra Copies',
    }
  }

  render() {
    const data = this.props.statuses.map((status, i) => {
      let groupedOrders = $.grep(this.props.data, (order) => {
        return order.status == status;
      })
      return (
        <div key={i}>
          <div className="d-flex-row">
            <div className="col">
              <div className="mb-2">
                <h4 className="fw-medium">{this.humanizeStatus()[status]} ({groupedOrders.length})</h4>
              </div>
            </div>
          </div>
          <div className="d-flex-row">
            <ul className="list-group list-group-flush mb-6">
              { groupedOrders.map((order) => {
                return ( <PrepressExtraCopyItem order={order} key={order.id}/> )
              })}
            </ul>
          </div>
        </div>
      )
    })
    return (
      <div>
        {data}
      </div>
    )
  }
}

export default PrepressExtraCopiesIndex
